import { render } from "./generic.vue?vue&type=template&id=380164ec&ts=true"
import script from "./generic.vue?vue&type=script&lang=ts"
export * from "./generic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__